import { ReferralType } from '@wix/da-bi/pkg/constants';

export type SisuActionKey =
  | 'download'
  | 'comment'
  | 'favourite'
  | 'add_to_group'
  | 'add_to_private_collection'
  | 'default';

export function getSisuActionKey(referralType?: ReferralType): SisuActionKey {
  switch (referralType) {
    case ReferralType.ANON_DOWNLOAD:
      return 'download';
    case ReferralType.COMMENT:
    case ReferralType.COMMENT_ACTION:
      return 'comment';
    case ReferralType.FAVOURITE:
      return 'favourite';
    case ReferralType.ADD_TO_GROUP:
      return 'add_to_group';
    case ReferralType.ADD_TO_PRIVATE_COLLECTION:
      return 'add_to_private_collection';
    default:
      return 'default';
  }
}
